import React from "react"
import { Layer } from "react-map-gl"

interface Props {
  id: string
}

const EmptyLayer: React.FC<Props> = ({ id }) => {
  return <Layer id={id} type="background" layout={{ visibility: "none" }} paint={{}} />
}

export default EmptyLayer
